import React from "react";
import CommonDataTable from "../../../../components/Datatable/CommonDataTable";
import CommonDropdown from "../../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../../components/dropdown/DropdownButton";
import Badge from "../../../../components/Common/Badge/Badge";
import ButtonRounded from "../../../../components/buttons/ButtonRounded";
import { AppContext } from "../../../../contexts/AppContext";
import CommonsHelper from "../../../../helpers/CommonsHelper";
import { formataDataMes } from "../../../../helpers/mesesHelper";
import { FaPlus } from "react-icons/fa6";
import Format from "../../../../helpers/Format";
import PropTypes from "prop-types";
import { handleChangeTableCheckbox } from "../../../../helpers/handleFormChanges";

function ProLaboreDataTable({
  linhas,
  togNovoProLaboreModal,
  visualizarDocumento,
  excluirProLabore,
  pagarProLabore,
  downloadDocumento,
  checkboxesHook,
  togDownloadMassaModal,
}) {
  const { checkboxesMarcados, setCheckboxesMarcados } = checkboxesHook;
  const { session } = React.useContext(AppContext);
  const isMobile = CommonsHelper.isMobile();

  const colunas = React.useMemo(
    () => [
      {
        Header: "",
        accessor: "id",
        disableSortBy: true,
        Cell: ({ row }) => (
          <input
            className="form-check-input"
            type="checkbox"
            name="proLabore"
            value={row.original.uid}
            checked={checkboxesMarcados.includes(String(row.original.uid))}
            onChange={(e) => {
              handleChangeTableCheckbox(
                e,
                checkboxesMarcados,
                setCheckboxesMarcados
              );
            }}
          />
        ),
      },
      {
        Header: "Sócio",
        accessor: "nome_empresarial",
        disableSortBy: true,
      },
      {
        Header: "Tipo de retirada",
        accessor: "tipo_retirada",
        disableSortBy: true,
      },
      {
        Header: "Mês de referência",
        disableSortBy: true,
        accessor: (row) => {
          return formataDataMes(row.mesano);
        },
      },
      {
        Header: "Valor líquido",
        accessor: (row) => {
          return Format.formataValor(row.valor_liquido ?? 0);
        },
        disableSortBy: true,
      },
      {
        Header: "Status",
        disableSortBy: true,
        Cell: ({ row }) => {
          let status = [];

          if (row.original.status === "PENDENTE") {
            status.push(
              <div>
                <Badge color="warning">Pendente</Badge>
              </div>
            );
          } else {
            status.push(
              <div>
                <Badge color="success">Pago</Badge>
              </div>
            );
          }

          return (
            <div>
              <div className="mb-2" role="group">
                {status}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [];

          status.push(
            <>
              <DropdownButton
                key={`download-${row.original.uid}`}
                onClick={() => {
                  downloadDocumento(
                    row.original.caminho,
                    Format.removeCaracteresInvalidos(row.original.tipo_retirada)
                  );
                }}
                color="success"
                icon="mdi mdi-cloud-download"
              >
                Download
              </DropdownButton>
            </>
          );

          if (!isMobile)
            status.push(
              <DropdownButton
                key={`visualizar-${row.original.uid}`}
                onClick={() => {
                  visualizarDocumento(row.original.caminho);
                }}
                color="primary"
                icon="mdi mdi-file-search"
              >
                Visualizar
              </DropdownButton>
            );

          status.push(
            <DropdownButton
              key={`pagamento-${row.original.uid}`}
              onClick={() => {
                pagarProLabore(
                  row.original.uid,
                  row.original.status === "PAGO"
                );
              }}
              color="warning"
              icon="mdi mdi-cash-check"
            >
              {row.original.status === "PAGO"
                ? "Cancelar pagamento"
                : "Informar pagamento"}
            </DropdownButton>
          );

          if (parseInt(session?.codigo) >= 10)
            status.push(
              <DropdownButton
                key={`excluir-${row.original.uid}`}
                onClick={() => {
                  excluirProLabore(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-delete"
              >
                Excluir
              </DropdownButton>
            );

          return <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [
      checkboxesMarcados,
      setCheckboxesMarcados,
      isMobile,
      session?.codigo,
      downloadDocumento,
      visualizarDocumento,
      pagarProLabore,
      excluirProLabore,
    ]
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      botoes={
        <>
          {parseInt(session?.codigo) !== 99 ? null : (
            <ButtonRounded
              onClick={() => {
                togNovoProLaboreModal();
              }}
              color="success"
              icon={<FaPlus />}
            >
              Novo pró-labore
            </ButtonRounded>
          )}
          <ButtonRounded
            onClick={() => {
              togDownloadMassaModal("Prolabore");
            }}
            color="success"
            icon={null}
          >
            Download em massa
          </ButtonRounded>
        </>
      }
    />
  );
}

ProLaboreDataTable.propTypes = {
  linhas: PropTypes.array.isRequired,
  togNovoProLaboreModal: PropTypes.func.isRequired,
  visualizarDocumento: PropTypes.func.isRequired,
  excluirProLabore: PropTypes.func.isRequired,
  pagarProLabore: PropTypes.func.isRequired,
  downloadDocumento: PropTypes.func.isRequired,
  checkboxesHook: PropTypes.shape({
    checkboxesMarcados: PropTypes.arrayOf(PropTypes.string).isRequired,
    setCheckboxesMarcados: PropTypes.func.isRequired,
  }).isRequired,
  togDownloadMassaModal: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default ProLaboreDataTable;
